module.exports = __webpack_public_path__ + "static/media/rollerblade6.17f27cbd.gif";